module.exports = __webpack_public_path__ + "media/images/application/template/footer-logo-2-4d3fd306d503a24faa874104c79a9edf.png";